import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=10afd79a&scoped=true&lang=pug&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=10afd79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10afd79a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10afd79a')) {
      api.createRecord('10afd79a', component.options)
    } else {
      api.reload('10afd79a', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=10afd79a&scoped=true&lang=pug&", function () {
      api.rerender('10afd79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Spinner.vue"
export default component.exports